<template>
  <div class="progress-wrap">
    <div class="file-info">
      <div class="file-info__name">
        <span class="file-info__id">{{ fileId }}</span>
        <span class="file-info__extension">{{ fileExt }}</span>
      </div>
      <div class="progress">
        <div v-if="isPaused" class="file-info__progress">
          <i class="fa fa-pause" aria-hidden="true" />
        </div>
        <div v-else-if="isStopped" class="file-info__progress">
          <i class="fa fa-stop" aria-hidden="true" />
        </div>
        <div v-else class="file-info__progress">{{ `${progress}%` }}</div>
        <div
          :class="`progress-bar ${progressClass}`"
          :style="`width: ${progress}%;`"
        />
      </div>
    </div>
    <div class="file-info__controls">
      <button v-if="isFinished && !isSucceed" class="button retry" @click="onRetryClicked">
        <i class="fa fa-repeat" aria-hidden="true" />
      </button>
      <template v-if="!isFinished">
        <button v-if="!isStopped" class="button stop" @click="onStopClicked">
          <i class="fa fa-stop" aria-hidden="true" />
        </button>
        <button v-if="!isStopped && isPaused" class="button resume" @click="onResumeClicked">
          <i class="fa fa-play" aria-hidden="true" />
        </button>
        <button v-else class="button pause" @click="onPauseClicked">
          <i class="fa fa-pause" aria-hidden="true" />
        </button>
      </template>
      <button v-else class="button remove" @click="onRemoveClicked">
        <i class="fa fa-times" aria-hidden="true" />
      </button>
    </div>
  </div>
</template>

<script>
import { uploadStatus } from '../../helpers/constants';

const {
  LOADING,
  ABORTED,
  SUCCESS,
  ERROR,
  PAUSE,
} = uploadStatus;

export default {
  name: 'ProgressBar',
  props: {
    progress: {
      type: Number,
      default: 0,
    },
    fileName: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: LOADING,
    },
  },
  data: () => ({
    isStopped: false,
    isPaused: false,
    isFinished: false,
    isSucceed: false,
    fileId: '',
    fileExt: '',
    progressClass: '',
  }),
  watch: {
    progress() {
      this.$forceUpdate();
    },
    fileName(val) {
      this.splitFileName(val);
    },
    status(val) {
      this.progressClass = val;
      switch (val) {
      case ERROR: {
        this.isFinished = true;
        this.isStopped = false;
        this.isSucceed = false;
        this.isPaused = false;
        break;
      }
      case ABORTED: {
        this.isFinished = true;
        this.isStopped = true;
        this.isSucceed = false;
        this.isPaused = false;
        break;
      }
      case SUCCESS: {
        this.isFinished = true;
        this.isSucceed = true;
        this.isPaused = false;
        this.isStopped = false;
        break;
      }
      case PAUSE: {
        this.isFinished = false;
        this.isSucceed = false;
        this.isStopped = false;
        this.isPaused = true;
        break;
      }
      default: {
        this.isFinished = false;
        this.isSucceed = false;
        this.isStopped = false;
        this.isPaused = false;
        break;
      }
      }
    },
  },
  mounted() {
    this.splitFileName(this.fileName);
  },
  methods: {
    splitFileName(name) {
      const lastPoint = name.lastIndexOf('.');
      this.fileId = name.substring(0, lastPoint);
      this.fileExt = name.substring(lastPoint);
    },
    onStopClicked() {
      // eslint-disable-next-line no-restricted-globals
      if (confirm('The upload will be stopped. Are you sure?')) {
        this.isStopped = true;
        this.$emit('stop-clicked');
      }
    },
    onResumeClicked() {
      this.isPaused = false;
      this.$emit('resume-clicked');
    },
    onPauseClicked() {
      this.isPaused = true;
      this.$emit('pause-clicked');
    },
    onRetryClicked() {
      this.isStopped = false;
      this.$emit('retry-clicked');
    },
    onRemoveClicked() {
      this.$emit('remove-clicked');
    },
  },
};
</script>

<style scoped>
.progress-bar {
  display: flex;
  flex-flow: row nowrap;
}
</style>



// WEBPACK FOOTER //
// ProgressBar.vue?0290955e